/**
 * point_width
 * point_color
 * point_border_color
 * point_border_width
 */

module.exports = function(style, zindex, scale) {
    // кружок для рисования
    var circle = new ol.style.Circle({
        radius: style['point_width'] * scale,
        fill  : new ol.style.Fill({
            color: style['point_color']
        }),
        stroke: new ol.style.Stroke({
            color: style['point_border_color'],
            width: style['point_border_width'] * scale,
            // linedash: style['line_border_style']
        })
    });

    if (scale !== 1) { 
        circle.setScale(1 / scale); 
    }

    /* обычный стиль */
    var regular = new ol.style.Style({
        image : circle,
        zIndex: zindex
    });

    return [regular];
};



//////////////////
// WEBPACK FOOTER
// ./src/View/PublicMapDraw/point-style.js
// module id = 232
// module chunks = 0